<template>
  <picture class="block w-full aspect-4/3 md:aspect-16/9 overflow-hidden rounded-image">
    <slot />
  </picture>
</template>
